/**
 * Video que se reproduce al entrar en pantalla.
 *
 * El archivo empieza a descargarse en cuanto carga la pagina —`preload="auto"`
 * en el marcado—, asi que cuando la persona baja hasta la seccion ya esta listo
 * y arranca sin espera.
 *
 * Reproduccion automatica solo si va en silencio: es lo que exigen los
 * navegadores, y es lo correcto. Con `prefers-reduced-motion` no arranca solo y
 * aparecen los controles, para que lo vea quien quiera verlo.
 */
class RitVideo extends HTMLElement {
  #video = null;
  #observador = null;

  connectedCallback() {
    this.#video = this.querySelector('video');
    if (!this.#video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#video.controls = true;
      return;
    }

    this.#observador = new IntersectionObserver(this.#alEntrar, { threshold: 0.4 });
    this.#observador.observe(this);
  }

  disconnectedCallback() {
    this.#observador?.disconnect();
  }

  #alEntrar = ([entrada]) => {
    if (!this.#video) return;

    if (entrada.isIntersecting) {
      const promesa = this.#video.play();
      // Si el navegador la rechaza igualmente, se muestran los controles en vez
      // de dejar un cuadro quieto sin explicacion.
      promesa?.catch(() => {
        this.#video.controls = true;
      });
      this.dataset.playing = 'true';
    } else if (this.dataset.pauseOffscreen === 'true') {
      this.#video.pause();
      this.dataset.playing = 'false';
    }
  };
}

if (!customElements.get('rit-video')) customElements.define('rit-video', RitVideo);
